export const BUY_URL =
  "https://kit-rrhh-chile.impultienda.ar/checkout/plan-base";
export const SUPPORT_EMAIL = "EbookDreamShop@gmail.com";
export const META_PIXEL_ID = "1252242806993118";

export const PRODUCT_IMAGE =
  "https://cdn.magicpatterns.com/uploads/myEvH4i7YikWTh66EkYL4f/ChatGPT_Image_Jul_27,_2026,_03_01_09_AM.png";

export const OFFICE_BG =
  "https://cdn.magicpatterns.com/patterns/generated-images/50739852-e81e-4817-b3a8-9681e2a49663.jpg";

export const BONUS_IMAGES = {
  finiquito:
    "https://cdn.magicpatterns.com/patterns/generated-images/4e857010-bf72-40e6-a573-0f0449977742.jpg",
  contratos:
    "https://cdn.magicpatterns.com/patterns/generated-images/7c4b1b65-55c7-417a-b0d2-fe5195074281.jpg",
  onboarding:
    "https://cdn.magicpatterns.com/patterns/generated-images/93f4fc78-daab-41fd-afa7-e850cbf8bdea.jpg",
  escritos:
    "https://cdn.magicpatterns.com/patterns/generated-images/78799e39-73d3-42e9-a0c8-7354108cf89b.jpg",
};

// ---- Product previews (carousel) ----
export const PREVIEW_IMAGES = [
  {
    src: "https://cdn.magicpatterns.com/uploads/5wYkMxnv5sonH4anKau7zs/Screenshot_2026-07-27_at_4.04.43_PM.png",
    label: "Guía RRHH para PyMEs (PDF)",
    caption: "Previred, feriado legal progresivo y gratificación explicados.",
  },
  {
    src: "https://cdn.magicpatterns.com/uploads/kfNw9rvH31nFpYxhqKDM8z/Screenshot_2026-07-27_at_4.04.48_PM.png",
    label: "Calendario de obligaciones (PDF)",
    caption: "Término de contrato, fiscalizadores y plazos mes a mes.",
  },
  {
    src: "https://cdn.magicpatterns.com/uploads/sBDjNeNfSNyxR9fkAdpQiX/Screenshot_2026-07-27_at_4.05.13_PM.png",
    label: "Asistencia y Permisos (Excel)",
    caption: "Registro diario con leyenda de atrasos, licencias y permisos.",
  },
  {
    src: "https://cdn.magicpatterns.com/uploads/xuEw4ksvnXfUxae8sDouMT/Screenshot_2026-07-27_at_4.05.33_PM.png",
    label: "Feriado Legal y Progresivo (Excel)",
    caption: "Calcula días base y progresivos solo con la fecha de ingreso.",
  },
  {
    src: "https://cdn.magicpatterns.com/uploads/trHaryc37QztdHmKrUJvRJ/Screenshot_2026-07-27_at_4.05.50_PM.png",
    label: "Carta de Amonestación (Word)",
    caption: "Modelo editable listo para completar y firmar.",
  },
  {
    src: "https://cdn.magicpatterns.com/uploads/tSXM6diyWturX9u5GtQhGP/Screenshot_2026-07-27_at_4.06.15_PM.png",
    label: "Guía de Contratos de Trabajo (PDF)",
    caption: "Tipos de contrato, cláusulas obligatorias y errores frecuentes.",
  },
];

// Chilean HR palette
export const COLORS = {
  green: "#1f4d3a",
  greenMid: "#2f6b4f",
  greenLight: "#e7f0ea",
  cream: "#f6f4ec",
  gold: "#c7a24a",
};

export function scrollToBuy() {
  const el = document.getElementById("compra");
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
}

// ---- Reviews (Gmail-style screenshots) ----
export const GMAIL_REVIEWS = [
  {
    name: "Camila Rojas",
    email: "camila.rojas@gmail.com",
    subject: "Gracias, me salvó con el finiquito",
    body:
      "Hola! Solo quería agradecer, ayer tuve que hacer un finiquito urgente y con la planilla lo dejé listo en 15 minutos. No sabís el peso que me sacaste de encima 🙏",
    time: "10:24",
    initials: "CR",
    color: "#1f4d3a",
  },
  {
    name: "Francisca Muñoz",
    email: "fran.munoz@gmail.com",
    subject: "El libro de remuneraciones es un golazo",
    body:
      "Trabajo sola en RRHH de una pyme en Valparaíso y andaba perdida con las remuneraciones. El Excel viene con todo calculado, cero cachos. Recomendadísimo.",
    time: "Ayer",
    initials: "FM",
    color: "#2f6b4f",
  },
  {
    name: "Daniela Contreras",
    email: "dani.contreras@gmail.com",
    subject: "Al fin dejo de improvisar",
    body:
      "Compré el kit el finde y ya lo estoy usando en la empresa. El feriado progresivo siempre me lo enredaba, ahora sale solo. Vale cada peso 💚",
    time: "3 jul",
    initials: "DC",
    color: "#c7a24a",
  },
  {
    name: "Paula Vergara",
    email: "paula.vergara@gmail.com",
    subject: "Entrega inmediata de verdad",
    body:
      "Lo pagué y me llegó al toque al correo. Todo en PDF y Excel listos para usar. Justo lo que necesitaba estando sola en el área. Gracias!",
    time: "1 jul",
    initials: "PV",
    color: "#1f4d3a",
  },
];

// ---- Common problems ----
export const PROBLEMS = [
  "Tenís que calcular finiquitos, gratificaciones y feriado legal sin equipo que te apoye.",
  "Vivís con el miedo de una multa de la Dirección del Trabajo por un error administrativo.",
  "Improvisás cada documento (contratos, amonestaciones, avisos) porque no tenís plantillas.",
  "Se te va el día en tareas repetitivas de planillas en vez de en lo importante.",
  "Nadie te enseñó formalmente RRHH y tenís que aprender sobre la marcha, sola.",
];

// ---- Modules (accordion) ----
export const MODULES = [
  {
    title: "📋 Ficha Digital del Trabajador",
    body:
      "Planilla lista para centralizar todos los datos de cada colaborador: contrato, cargo, sueldo, AFP, salud, cargas y documentos. Se acabó buscar información en 5 carpetas distintas.",
  },
  {
    title: "🏖️ Feriado Legal Progresivo",
    body:
      "Calcula automáticamente los días de vacaciones de cada trabajador, incluyendo el feriado progresivo por antigüedad. Solo ingresás la fecha de ingreso y el Excel hace el resto.",
  },
  {
    title: "💰 Gratificación Legal",
    body:
      "Determina la gratificación legal según el tope del 4,75 IMM o el 25% de las remuneraciones, según lo que corresponda. Cumplís la ley sin dolores de cabeza.",
  },
  {
    title: "📊 Libro de Remuneraciones",
    body:
      "Libro de remuneraciones electrónico con haberes, descuentos legales y líquido a pagar calculado por ti. Ordenado, claro y listo para fiscalización.",
  },
  {
    title: "🕒 Asistencia y Permisos",
    body:
      "Control de asistencia, atrasos, horas extra y permisos en una sola planilla. Sabés al instante quién está, quién falta y por qué.",
  },
];

// ---- Bonuses (accordion) ----
export const BONUSES = [
  {
    title: "🎁 Finiquito (Excel)",
    body:
      "Planilla que calcula el finiquito completo: indemnización por años de servicio, mes de aviso, feriado proporcional y más. Ingresás los datos y obtenés el monto exacto.",
    img: "finiquito" as const,
  },
  {
    title: "📑 Guía de Contratos de Trabajo (PDF)",
    body:
      "Guía práctica con tipos de contrato, cláusulas obligatorias, los 5 errores más comunes en pymes y un modelo de anexo de contrato listo para usar.",
    img: "contratos" as const,
  },
  {
    title: "✅ Checklist + Onboarding (PDF + Excel)",
    body:
      "Checklist de contratación e inducción para que ningún nuevo trabajador se te escape sin documentos ni pasos legales. Incluye versión imprimible y editable.",
    img: "onboarding" as const,
  },
  {
    title: "📝 Modelos de Escritos (3 Word)",
    body:
      "Carta de Amonestación, Aviso de Término (art. 161) y Carta de Renuncia Voluntaria. Documentos editables en Word para actuar rápido y bien redactado.",
    img: "escritos" as const,
  },
  {
    title: "💬 Guion de Conversaciones Difíciles (Word)",
    body:
      "Frases y estructura para llevar conversaciones incómodas: llamados de atención, desvinculaciones y feedback. Para que digas lo correcto sin quebrarte.",
    img: "escritos" as const,
  },
  {
    title: "📕 Reglamento Interno de Orden, Higiene y Seguridad",
    body:
      "14 títulos y 27 artículos: cubre ingreso, jornada, remuneraciones, obligaciones y prohibiciones, igualdad de remuneraciones (Ley 20.348), sanciones y todo el bloque de higiene y seguridad (D.S. 40), con Comité Paritario condicional a 25+ trabajadores. Hace referencia cruzada a los módulos del kit en vez de repetir contenido.",
    img: "contratos" as const,
  },
  {
    title: "🛡️ Protocolo Ley Karin",
    body:
      "Definiciones legales, tabla de plazos del procedimiento de investigación (3 días para decidir la vía, 30 días de investigación, 2 días para enviar a la DT) y formulario tipo de denuncia como anexo. Obligatorio para toda empresa sin mínimo de trabajadores — a diferencia del RIOHS.",
    img: "escritos" as const,
  },
];

// ---- Short testimonials ----
export const TESTIMONIALS = [
  {
    name: "Javiera Soto",
    role: "Encargada de RRHH · Santiago",
    age: 34,
    text:
      "Soy la única del área en una empresa de 40 personas. Este kit es como tener a alguien que me guía. Me ahorra horas todas las semanas.",
  },
  {
    name: "Constanza Herrera",
    role: "Administración y Personas · Concepción",
    age: 29,
    text:
      "Andaba con miedo a equivocarme en las remuneraciones. Ahora tengo todo ordenado y respaldado. Dormí tranquila por primera vez en meses.",
  },
  {
    name: "María José Fuentes",
    role: "Jefa Administrativa · Viña del Mar",
    age: 41,
    text:
      "Lo mejor son los modelos de escritos. Antes googleaba cada carta, ahora solo edito y listo. Súper profesional el resultado.",
  },
  {
    name: "Antonia Riquelme",
    role: "Encargada de Personas · La Serena",
    age: 31,
    text:
      "El cálculo del feriado progresivo me tenía loca. Con el Excel salió al primer intento. Recomendado 100% para quienes están solas en esto.",
  },
  {
    name: "Valentina Cáceres",
    role: "RRHH PYME · Rancagua",
    age: 27,
    text:
      "Entrega inmediata, todo en PDF y Excel, sin cursos eternos. Justo lo que necesitaba. Vale muchísimo más que los 17 dólares.",
  },
];

// ---- Objections ----
export const OBJECTIONS = [
  {
    q: "¿Sirve si no sé nada de RRHH?",
    a: "Sí. Todo viene explicado paso a paso y las planillas calculan solas. Está pensado justamente para quienes hacen RRHH sin ser expertos y sin equipo.",
  },
  {
    q: "¿Está actualizado a la legislación chilena?",
    a: "Sí. Cálculos de finiquito, gratificación, feriado progresivo y libro de remuneraciones siguen la normativa laboral vigente en Chile.",
  },
  {
    q: "¿Cómo lo recibo?",
    a: "Al instante. Apenas confirmás el pago, te llega el acceso a tu correo. Sin esperas, sin envíos físicos.",
  },
  {
    q: "¿En qué formato están los archivos?",
    a: "Las herramientas core y varios bonos son Excel editables, las guías en PDF y los modelos de escritos en Word. Los abrís y usás de inmediato.",
  },
  {
    q: "¿Y si no me sirve?",
    a: "Escribinos a soporte y te ayudamos. Queremos que el kit realmente te ordene el área, no que quede guardado.",
  },
];

// ---- Pop-up buyers ----
export const POPUP_BUYERS = [
  { name: "Martín", city: "Buenos Aires" },
  { name: "Lucía", city: "Córdoba" },
  { name: "Sofía", city: "Rosario" },
  { name: "Mateo", city: "Mendoza" },
  { name: "Valentina", city: "La Plata" },
  { name: "Tomás", city: "Mar del Plata" },
  { name: "Camila", city: "Salta" },
  { name: "Joaquín", city: "San Juan" },
  { name: "Agustina", city: "Neuquén" },
  { name: "Benjamín", city: "Tucumán" },
];
